export const fullApplicationTitle = `Let's get started on your loan application`;
export const followUpOnlyTitle = `Create an account to activate your loan hub`;
export const mobileViewTitle = `Choose a password to get started`;
